export default __webpack_public_path__ + "static/media/Polygon.a9183565.png";